import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Icon } from '../../../';
import { NavDropdown } from './NavDropdown';
export var SupportDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(SupportDropdown, _React$Component);

  var _super = _createSuper(SupportDropdown);

  function SupportDropdown() {
    _classCallCheck(this, SupportDropdown);

    return _super.apply(this, arguments);
  }

  _createClass(SupportDropdown, [{
    key: "render",
    value: function render() {
      var inverted = this.props.inverted;
      return /*#__PURE__*/React.createElement(NavDropdown, {
        className: "cloud-ui-support-dropdown",
        inverted: inverted,
        label: /*#__PURE__*/React.createElement("div", {
          className: "nav-icon-wrapper",
          "data-qa": "support-dropdown"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "help-outline"
        })),
        pinned: true,
        position: "bottom right",
        tooltip: "Support"
      });
    }
  }]);

  return SupportDropdown;
}(React.Component);